import { memo, useEffect, useMemo, useState } from 'react'
import './EditMemberImage.scss'
import defaultImageIcon from '../../../../images/management/clinicMembers/voidPhoto.png'
import { imageSize } from '../../../../utils/common'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../utils/errormessages'

export const EditMemberImage = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    style,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isVisible,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isViewMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isImageChanged,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    profileImgInputValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setProfileImgInputValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsImageChanged,
  }) => {
    const [localImgInputValue, setLocalImgInputValue] = useState(profileImgInputValue)
    const [imgStyleObject, setImgStyleObject] = useState({})
    const [profileImgInputLocalError, setProfileImgInputLocalError] = useState('')

    useEffect(() => {
      if (profileImgInputValue && !isImageChanged) {
        imageSize(profileImgInputValue).then((e) => {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (e?.width > e?.height) {
            setImgStyleObject({ height: '100%', width: '' })
          } else {
            setImgStyleObject({
              height: '',
              width: '100%',
            })
          }
          setLocalImgInputValue(profileImgInputValue)
        })
      }
    }, [isImageChanged])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onNewImgSelected = (e) => {
      const allowedExtensions = /(\/jpg|\/jpeg|\/png)$/i
      const allowedExtensionsNameList = ['jpg', 'jpeg', 'png']
      const file = e.target.files[0]
      if (file) {
        const splittedFileName = file.name.split('.')
        if (file.size > 10485760) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setProfileImgInputLocalError(getUserFriendlyErrorMessage(errorCodes.TOO_BIG_FILE_SIZE, null, '10 MB'))
          return false
        }
        if (
          !allowedExtensions.exec(file.type) ||
          !allowedExtensionsNameList.find((el) => el === splittedFileName[splittedFileName.length - 1].toLowerCase())
        ) {
          setProfileImgInputLocalError(
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(errorCodes.INVALID_FILE_FORMAT, null, '.jpg, .jpeg, .png'),
          )
          return false
        }
        const fr = new FileReader()

        imageSize(URL.createObjectURL(file)).then((e) => {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          if (e.width > e.height) {
            setImgStyleObject({ height: '100%', width: '' })
          } else {
            setImgStyleObject({ height: '', width: '100%' })
          }
          fr.readAsDataURL(file)
          setProfileImgInputValue(file)
          setLocalImgInputValue(URL.createObjectURL(file))
          setIsImageChanged(true)
          setProfileImgInputLocalError('')
        })
      }
    }

    const editMemberImageStyle = useMemo(
      () => ({
        visibility: isVisible ? 'visible' : 'hidden',
        marginRight: 32,
        ...style,
      }),
      [isVisible, style],
    )
    const borderImgWrapperStyle = useMemo(
      () => ({ border: profileImgInputValue ? '1px solid #C2D5E2' : 'none' }),
      [profileImgInputValue],
    )
    return (
      <div style={editMemberImageStyle} className='edit-member-image-block'>
        <div className='circularImg' style={borderImgWrapperStyle}>
          <img
            className={profileImgInputValue ? 'edit-member-image' : 'edit-member-empty-img'}
            style={imgStyleObject}
            src={localImgInputValue ?? defaultImageIcon}
            alt='defaultImageIcon'
            id='profileIcon'
          />
        </div>
        {!isViewMode && (
          <div className='inputBlock'>
            <label htmlFor='profileImg' className='edit-member-image-text'>
              {profileImgInputValue ? 'Edit profile picture' : 'Add profile picture'}
            </label>
            <input id='profileImg' onChange={onNewImgSelected} type='file' accept='image/png,image/jpeg' />
            <div className='inputBlockErrorMessage'>{profileImgInputLocalError}</div>
          </div>
        )}
      </div>
    )
  },
)
